export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-960-64e0ffa139a8aa545da9bebb02b1f456.webp";